document.addEventListener('DOMContentLoaded', function () {
  const options = document.querySelectorAll('.apartments-filters-option')
  const apartments = document.querySelectorAll('.apartments-item')

  options.forEach((option) => {
    option.addEventListener('change', function () {
      const activeRooms = Array.from(options)
        .filter((opt) => opt.querySelector('input').checked)
        .map((opt) => opt.getAttribute('data-room-show'))

      if (activeRooms.length === 0) {
        apartments.forEach((apartment) => {
          apartment.classList.add('is-active')
        })
      } else {
        apartments.forEach((apartment) => {
          if (activeRooms.includes(apartment.getAttribute('data-room'))) {
            apartment.classList.add('is-active')
          } else {
            apartment.classList.remove('is-active')
          }
        })
      }
    })
  })
})
